import {
  UNTRUSTED_HTML_ALLOWED_LINK_SCHEMES,
  UNTRUSTED_HTML_INLINE_IMAGE_SOURCE_PATTERN,
} from '@this+that/constants';

const URL_SCHEME_PATTERN = /^([a-z][a-z0-9+.-]*):/i;
const LAST_SPACE_CODE = 0x20;
const FIRST_DELETE_CODE = 0x7f;
const LAST_C1_CODE = 0x9f;

const isIgnoredByBrowsers = (char: string): boolean => {
  const code = char.charCodeAt(0);
  return (
    code <= LAST_SPACE_CODE ||
    (code >= FIRST_DELETE_CODE && code <= LAST_C1_CODE)
  );
};

// Browsers skip whitespace and control characters anywhere in a URL scheme.
export const compactUrl = (raw: string): string =>
  [...raw].filter((char) => !isIgnoredByBrowsers(char)).join('');

export const isAllowedLinkUrl = (url: string): boolean => {
  const scheme = URL_SCHEME_PATTERN.exec(compactUrl(url))?.[1];
  return (
    scheme !== undefined &&
    UNTRUSTED_HTML_ALLOWED_LINK_SCHEMES.has(scheme.toLowerCase())
  );
};

export const isAllowedInlineImageSource = (src: string): boolean =>
  UNTRUSTED_HTML_INLINE_IMAGE_SOURCE_PATTERN.test(compactUrl(src));
